import { getMessaging, getToken } from "firebase/messaging";
import app from "./firebaseKeys";
import { getFromStorage, setToStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../constants/storageKeys";

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const swRegistration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BN43RlgxYCDkbAAT8KX_mxOcPLnI--Hw1p6DkD-5_ecg_at79PgO3E6DiEYw0o3C7hOVkRak32afKBh4tjL4CSs",
          serviceWorkerRegistration: swRegistration,
        });

        if (fcm_token) {
          setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      } else {
        console.log("Notification permission not granted.");
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
